import React from "react"
import { useTranslation } from "react-i18next"

import { useAsideMenu } from "hooks/useAsideMenu"

import { MenuIcon, CrossIcon } from "components/Elements/Icons"

export const ToggleAsideNav = () => {
    const { menuIsOpen, toggleAsideMenu } = useAsideMenu()
    const { t } = useTranslation()
    
    return (
        <button
            className={"lg:hidden flex-col items-center u-pd-s text-white"}
            onClick={() => toggleAsideMenu()}
        >
            {!menuIsOpen &&
                <>
                    <MenuIcon size={25} />
                    <span className="mt-1 text-xxs">{t("menu.menu")}</span>
                </>
            }
            {menuIsOpen &&
                <>
                    <CrossIcon size={25} />
                    <span className="mt-1 text-xxs">{t("global.close")}</span>
                </>
            }
        </button>
    )
}
